import { createElement } from "react";
import { createReactRoot } from "common/react/create-react-root";
import PdpMadeReviews from "./PdpMadeReviews.vue";
import "./pdp-made-reviews.scss";

const RENDERED_ATTR = "data-react-pdp-made-reviews-rendered";

type Review = {
  [key: string]: unknown;
};

type Props = {
  rating: number;
  reviewsCount: number;
  reviews: Review[];
};

const parseNumber = (value: string | undefined): number => {
  if (!value) return 0;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const parseReviews = (value: string | undefined): Review[] => {
  if (!value) return [];

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const getProps = (mountPoint: HTMLElement): Props => ({
  rating: parseNumber(mountPoint.dataset["rating"] || mountPoint.dataset["ratingAvg"]),
  reviewsCount: parseNumber(mountPoint.dataset["reviewsCount"]),
  reviews: parseReviews(mountPoint.dataset["reviews"])
});

export function initReactPdpMadeReviews() {
  const mountPoint = document.querySelector<HTMLElement>(".js-react-pdp-made-reviews");
  if (!mountPoint || mountPoint.hasAttribute(RENDERED_ATTR)) return;

  mountPoint.setAttribute(RENDERED_ATTR, "true");

  createReactRoot(mountPoint, "PDP Made Reviews").render(
    createElement(PdpMadeReviews, getProps(mountPoint))
  );
}
